import { AppContext } from 'src/components/app-context';
import React, { useContext } from 'react';
import { Spinner } from 'src/components/spinner';
import * as S from './styles';
import type { NewsletterSignupProps } from './types';
import { useNewsletterSignup } from './useNewsletterSignup';
import LegalLink from './legal-link';

export const NewsletterSignupFooter = (props: NewsletterSignupProps) => {
  const {
    className,
    title,
    buttonText,
    buttonClass,
    stacked,
    variant = 'primary',
  } = props;
  const { t } = useContext(AppContext);
  const {
    state: { signupFeedbackTranslationKey, isSubscribed, loading },
    handleSubmit,
    handleChange,
    privacyPolicyUri,
  } = useNewsletterSignup();

  return (
    <S.NewsLetterFooter stacked={false} variant={variant} className={className}>
      <S.NewsLetterFooterText>
        {title && <S.Title>{title}</S.Title>}
      </S.NewsLetterFooterText>

      <S.NewsLetterFooterInput>
        {!isSubscribed ? (
          <S.Form method="post" onSubmit={handleSubmit}>
            <S.Flex>
              <S.InlineInput
                type="email"
                name="email"
                helper={t('campaigns', signupFeedbackTranslationKey!)}
                onChange={handleChange}
                stacked={stacked}
                variant="rounded"
                placeholder={t('campaigns', 'newsletter.email-placeholder')}
                ariaLabel={t('campaigns', 'newsletter.email-input-aria-label')}
                // Do not send this element to CUX (cux.io)
                data-cux-exclude
              />
              <S.Button
                className={buttonClass || ''}
                disabled={loading}
                htmlType="submit"
              >
                {loading && (
                  <S.ButtonIcon>
                    <Spinner position="none" isActive={loading} />
                  </S.ButtonIcon>
                )}
                <S.ButtonText $hide={loading}>
                  {buttonText || t('campaigns', 'newsletter.sign-up-button')}
                </S.ButtonText>
              </S.Button>
            </S.Flex>
          </S.Form>
        ) : (
          <S.Text>
            <S.SubscribedCheckIcon />
            <S.SubscribeTitle>
              {t('campaigns', 'newsletter.sign-up-success')}
            </S.SubscribeTitle>
          </S.Text>
        )}
      </S.NewsLetterFooterInput>

      <LegalLink privacyPolicyUri={privacyPolicyUri} />
    </S.NewsLetterFooter>
  );
};
